import React from "react";

import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import CankayaIntro from "../components/ServiceRegions/İntros/CankayaIntro";
import DynamicImage from "../components/DynamicImage";


const CankayaPage = () => {
  return (
    <> 
    <div>
        
      {/* <HeroSlider /> */}
      {/* <AboutSection/> */}
       <DynamicImage />
      <CankayaIntro/>
      <ServicesGrid />
      <BlogList/>
      <Testimonials/>
      <Footer/>
     
    </div>
     </>
  );
};

export default CankayaPage;
